import React from "react";
import PastTenYearsSelect from "../../../../../organizationsettings/profilepages/PastTenYearsSelect";

const PatientDetailsField = ({
  header,
  info,
  setSelectedYear,
  showSelect,
  selectedYear,
  joiningDate
}) => {
  return (
    <div className="description-section-data">
      <span className="description-section-data-header">
        {header}{" "}
        {showSelect && (
          <PastTenYearsSelect
            onChange={(value) => setSelectedYear(value)}
            value={selectedYear}
            fromTimestamp={joiningDate}
          />
        )}
      </span>
      <span className="description-section-card-content">{info}</span>
    </div>
  );
};

export default PatientDetailsField;
